import { v4 as uuidv4 } from 'uuid';

export const generateObjRefId = (prefix = 'object') => {
  return `${prefix}-${uuidv4()}`;
};
